<!--<template>
  <div class="tabs" :class="{ 'disabled': disabled }" >
    <div v-for="(tab, index) in tabs" class="tab" :key="index" :class="{'active': tab.value == value}" @click="update(tab.value)">
      <div class="copy">{{ tab.name }}</div>
      <span v-if="tab.icon" class="icon mdi" :class="tab.icon" ></span>
    </div>
  </div>
</template>-->

<template>
  <div class="tabs" :class="{ 'disabled': disabled}" id="filter-tabs">
    <div class="tab btn" :class="{ active: value === 'departure' }" @click="update('departure')">
      <div class="copy">{{ $t("tabs.departure") }}</div>
      <span class="mdi mdi-airplane-takeoff icon"></span>
    </div>
    <div class="tab btn" :class="{ active: value === 'arrival' }" @click="update('arrival')">
      <div class="copy" >{{ $t("tabs.arrival") }}</div>
      <span class="mdi mdi-airplane-landing icon"></span>
    </div>
     <div class="tab btn" :class="{ active: value === 'all' }" @click="update('all')">
      <div class="copy">{{ $t("tabs.all") }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Tabs',
  props: {
    tabs: Array,
    value: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    update(value) {
      if (value === this.value) return;
      this.$emit('update', value);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .tabs {
    width: 100%;
    height: 35px;
    position: relative;
    cursor: pointer;
    border-radius: 3px;
    text-align: center;
    background-color: $general-white;
    border: solid 1px $brand-primary-button;
    color: $brand-primary-button;

    display: flex;
    align-items: center;
    justify-content: center;

    &.disabled {
      pointer-events: none;
      color: $brand-primary-button-disabled;
      border: solid 1px $brand-primary-button-disabled;
    }

    .tab {
      width: auto;
      height: 100%;
      position: relative;
      padding: 0 20px;
      border-right: solid 1px $brand-primary-button;

      display: flex;
      align-items: center;
      justify-content: center;

      &:last-child {
        border-right: none;
      }

      &:hover {
        background-color: $brand-tertiary-button-hover;
      }

      &.active {
        color: $general-white;
        background-color: $brand-primary-button;
      }

      .copy {
        width: auto;
        position: relative;
        font-size: 12px;
        font-weight: 700;
        text-align: center;
      }

      .icon {
        width: auto;
        height: auto;
        font-size: 18px !important;
        margin-left: 10px;
      }
    }

    &.disabled .tab {
      border-right: solid 1px $brand-primary-button-disabled;
    }

    &.disabled .tab.active {
        color: $general-white;
        background-color: $brand-primary-button-disabled;
      }
    
  }

  @media screen and (max-width: 768px) {
    .tabs {
      height: auto;
      min-height: 35px;
      flex-wrap: wrap;

      .tab {
        padding: 0 12px;
        flex: 1 1 auto;

        .copy {
          font-size: 11px;
        }

        .icon {
          font-size: 16px !important;
          margin-left: 6px;
        }
      }
    }
  }
</style>
